import { Box } from '@mui/material';

export function TabsBody(props) {
  return (
    <Box
      sx={{ mt: '7px', display: 'flex', height: '100%', overflow: 'hidden' }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowX: 'auto',
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
}
